import React from "react";

import { APP_MODE, APP_VERSION, GIT_COMMIT_HASH } from "../../common/envconst";
import "./VersionDisplay.scss";

// Export the version string logic for testing
export const getVersionString = (env?: {
	VITE_APP_VERSION?: string;
	VITE_GIT_COMMIT?: string;
	MODE?: string;
	VITE_DD_ENV?: string;
}): string => {
	const appVersion = env?.VITE_APP_VERSION || APP_VERSION;
	const gitCommit = env?.VITE_GIT_COMMIT || GIT_COMMIT_HASH;
	const mode = env?.MODE || APP_MODE;

	// If we have build version (in production/staging builds)
	if (appVersion) {
		return `${appVersion}`;
	}

	// For development mode, use commit hash (first 7 characters)
	if (gitCommit) {
		return gitCommit.substring(0, 7);
	}

	// Fallback for development without git commit
	if (mode === "development") {
		return "dev";
	}

	return "unknown";
};

// Export the render logic for testing
export const shouldRenderVersion = (mode: string, versionString: string): boolean => {
	if (!versionString || (mode === "development" && versionString === "dev")) {
		return false;
	}

	return true;
};

const VersionDisplay: React.FC = () => {
	const versionString = getVersionString();
	const mode = APP_MODE;

	// Don't render if version string is empty or unknown in development
	if (!shouldRenderVersion(mode, versionString)) {
		return null;
	}

	return (
		<div className="VersionDisplay" title={`${versionString}`}>
			{versionString}
		</div>
	);
};

export default VersionDisplay;
